import HeadingNav from '../../../components/Layouts/HeadingNav';
import { useLocation, Redirect, useParams } from 'react-router-dom';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIRouterTabs from 'ui-addon-react-router-dom/UIRouterTabs';
import UIRouterTab from 'ui-addon-react-router-dom/UIRouterTab';
import { ListingPage } from 'foundations-components/transitional/components/ListingPage';
import { useEffect } from 'react';
import UsageTracker from '../../../utils/UsageTracker';
import { PAGE_NAMES } from '../../../constants/Navigation';
import TabLiner from '../components/common/TabLiner';
import { ALL_PLAYLISTS_PATH, COMPLETED_PLAYLISTS_PATH, INCOMPLETE_PLAYLISTS_PATH } from '../constants/routes';
import ACTableSkeleton from 'academy-common-lib/components/loading/ACTableSkeleton';
import { HasGate } from '../../accounts/components/HasGate';
import ApiError from '../../../components/Errors/ApiError';
import { MY_TEAM_PLAYLISTS_GATE } from '../constants/gating';
import { NavMarker } from 'react-rhumb';
import AllPlaylistsTable from '../components/playlists/AllPlaylistsTable';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const pageSize = 10;
export const RedirectToPlaylistsDefaultTab = () => {
  const location = useLocation();
  return /*#__PURE__*/_jsx(Redirect, {
    to: Object.assign({}, location, {
      pathname: ALL_PLAYLISTS_PATH
    })
  });
};
const PlaylistsSkeletonTable = () => /*#__PURE__*/_jsx(ACTableSkeleton, {
  columns: 5,
  condensed: true,
  headerRows: 1,
  rows: pageSize
});
const MyTeamPlaylists = () => {
  const {
    playlistStatus
  } = useParams();
  useEffect(() => {
    UsageTracker.track('pageView', {
      screen: PAGE_NAMES.MY_TEAM_PLAYLISTS
    });
  }, []);
  return /*#__PURE__*/_jsx(HasGate, {
    fallback: /*#__PURE__*/_jsx(ApiError, {
      error: {
        status: 404
      },
      marker404: "NO_ACCESS_404",
      showLink: false
    }),
    gate: MY_TEAM_PLAYLISTS_GATE,
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(HeadingNav, {
        subtitleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.heading.headingSubTitles.MY_TEAM_PLAYLISTS"
        }),
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.heading.headingTitles.MY_TEAM_PLAYLISTS"
        })
      }), /*#__PURE__*/_jsx(ListingPage, {
        headerComponent: null,
        children: /*#__PURE__*/_jsxs(UIRouterTabs, {
          children: [/*#__PURE__*/_jsx(UIRouterTab, {
            active: playlistStatus === 'all',
            replace: true,
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.myTeam.playlists.tabs.all"
            }),
            to: ALL_PLAYLISTS_PATH,
            children: /*#__PURE__*/_jsx(TabLiner, {
              children: /*#__PURE__*/_jsx(AllPlaylistsTable, {})
            })
          }), /*#__PURE__*/_jsx(UIRouterTab, {
            active: playlistStatus === 'completed',
            replace: true,
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.myTeam.playlists.tabs.completed"
            }),
            to: COMPLETED_PLAYLISTS_PATH,
            children: /*#__PURE__*/_jsx(TabLiner, {
              children: /*#__PURE__*/_jsx(NavMarker, {
                name: "MY_TEAM_PLAYLISTS_LOADED",
                children: /*#__PURE__*/_jsx(PlaylistsSkeletonTable, {})
              })
            })
          }), /*#__PURE__*/_jsx(UIRouterTab, {
            active: playlistStatus === 'incomplete',
            replace: true,
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.myTeam.playlists.tabs.incomplete"
            }),
            to: INCOMPLETE_PLAYLISTS_PATH,
            children: /*#__PURE__*/_jsx(TabLiner, {
              children: /*#__PURE__*/_jsx(NavMarker, {
                name: "MY_TEAM_PLAYLISTS_LOADED",
                children: /*#__PURE__*/_jsx(PlaylistsSkeletonTable, {})
              })
            })
          })]
        })
      })]
    })
  });
};
export default MyTeamPlaylists;